var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.org)?_c('CommonReleaseDetails',{staticClass:"inner-container main-pad-y",attrs:{"tabView":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }